import {EditProps} from "react-admin";
import {DefaultEdit} from "../components/DefaultEdit";
import {UserForm} from "./UserForm";


export const UserEdit = (props: EditProps) => {
    return (
        <DefaultEdit {...props} >
            <UserForm/>
        </DefaultEdit>
    );
}